module.exports = __webpack_public_path__ + "img/18.a77c2415.png";